/* PDP Add-to-Cart Success Feedback (Modern-Pattern)

   Lauscht auf Dawn's PUB_SUB_EVENTS.cartUpdate. Wenn die Quelle eine
   product-form ist, schaltet der zugehoerige Submit-Button kurzzeitig
   in den Success-State (Text "Hinzugefuegt" + Checkmark-Icon), dann
   zurueck zum Default-State.

   CSS-Hook: .product-form__submit.is-success
*/
(function () {
  var SUCCESS_DURATION_MS = 2200;
  var unsubscribe = null;

  function showSuccessOnButton(btn) {
    if (!btn) return;
    btn.classList.add('is-success');
    if (btn._atcSuccessTimer) clearTimeout(btn._atcSuccessTimer);
    btn._atcSuccessTimer = setTimeout(function () {
      btn.classList.remove('is-success');
    }, SUCCESS_DURATION_MS);
  }

  function attachSubscriber() {
    if (unsubscribe) return;
    if (typeof window.subscribe !== 'function') return;

    // Dawn definiert PUB_SUB_EVENTS in constants.js als top-level `const` —
    // das landet NICHT auf window. Wir nutzen daher den Event-Name-String
    // ('cart-update') direkt, der mit PUB_SUB_EVENTS.cartUpdate matched.
    unsubscribe = window.subscribe('cart-update', function (event) {
      if (!event || event.source !== 'product-form') return;

      // Find the submitting product-form by variant id, fall back to all visible PDP submit-buttons
      var variantId = event.productVariantId;
      var matched = false;
      document.querySelectorAll('product-form').forEach(function (form) {
        var input = form.querySelector('input[name="id"]');
        if (input && variantId && String(input.value) === String(variantId)) {
          var btn = form.querySelector('.product-form__submit');
          showSuccessOnButton(btn);
          matched = true;
        }
      });
      if (!matched) {
        // Fallback: erstes sichtbares PDP-Submit
        var btn = document.querySelector(
          '.product-form__buttons.has-cart-wishlist-row .product-form__submit'
        );
        showSuccessOnButton(btn);
      }
    });
  }

  // Wait for Dawn's pubsub to be loaded; pubsub.js runs early but is async.
  // Poll briefly until subscribe() exists.
  function init() {
    if (typeof window.subscribe === 'function') {
      attachSubscriber();
      return;
    }
    var attempts = 0;
    var iv = setInterval(function () {
      attempts++;
      if (typeof window.subscribe === 'function') {
        clearInterval(iv);
        attachSubscriber();
      } else if (attempts > 40) {
        clearInterval(iv); // give up after ~2s
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme-Editor reload: subscriber bleibt bestehen, nichts zu tun.
})();
